module.exports = __webpack_public_path__ + "static/media/search.0b6d8d5e.svg";